import {createRoot} from 'react-dom/client'
import AccordionGroup from '@/scripts/components/shared/accordion-group/AccordionGroup'
import DualAccordionGroup from '@/scripts/components/shared/accordion-group/DualAccordionGroup'
import React from 'react'
import '../../styles/core/details-accordions.scss'

function renderDualAccordions(sectionType, closeSiblings = `all`) {
    document.querySelectorAll(`[data-section-type="${sectionType}"] .dual-accordion-group`).forEach(accordion => {
        let columns = {
            first: [],
            second: [],
            firstClass: ``,
            secondClass: ``
        }
        let index = `first`
        accordion.querySelectorAll(`.accordion-column`).forEach(column => {
            column.querySelectorAll(`details.accordion-details`).forEach(child => {
                let summaryChild = child.querySelector(`summary`)
                let headerChild = summaryChild.querySelector(`h4`)
                let contentChild = child.querySelector(`div`)

                columns[index].push(
                    {
                        id: child.id,
                        header: headerChild.innerHTML.trim(),
                        headerClass: headerChild.classList.toString(),
                        summaryClass: summaryChild.classList.toString(),
                        content: contentChild.innerHTML.trim(),
                        contentClass: contentChild.classList.toString(),
                        className: child.classList.toString(),
                        column_id: index
                    }
                )
            })
            if (index === `first`) {
                columns.firstClass = column.classList.toString()
            } else {
                columns.secondClass = column.classList.toString()
            }
            index = `second`
        })

        let root = createRoot(accordion)
        root.render(<DualAccordionGroup columns={columns} closeSiblings={closeSiblings}/>)
    })
}

function renderAccordions(sectionType, closeSiblings = true, openFirstAllowed = false) {
    document.querySelectorAll(`[data-section-type="${sectionType}"] .accordion-group`).forEach(accordion => {
        let items = []
        let first = true
        accordion.querySelectorAll(`details.accordion-details`).forEach(child => {
            let summaryChild = child.querySelector(`summary`)
            let headerChild = summaryChild.querySelector(`h4`)
            let contentChild = child.querySelector(`div`)
            let open = openFirstAllowed && first && child.open
            first = false
            items.push(
                {
                    id: child.id,
                    header: headerChild.innerHTML.trim(),
                    headerClass: headerChild.classList.toString(),
                    summaryClass: summaryChild.classList.toString(),
                    content: contentChild.innerHTML.trim(),
                    contentClass: contentChild.classList.toString(),
                    className: child.classList.toString(),
                    open: open
                }
            )
        })
        let root = createRoot(accordion)
        const hrDisplay = accordion.dataset.hrDisplay || `include`
        root.render(<AccordionGroup items={items} closeSiblings={closeSiblings} include_hr={hrDisplay === `include`} openFirstAllowed={openFirstAllowed} />)
    })
}

export {renderAccordions, renderDualAccordions}
